import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";

export const getCaptcha = createAsyncThunk("login/getCaptcha", async() => {
    let captchaObject = {};
    await axios.get('https://demo.khedmatashayer-kj.ir/api/v1/captcha')
        .then((response) => {
            captchaObject = {
                key: response.data.key,
                image: response.data.image
            }
        })
        .catch(() => {
            alert('خطا در برقراری ارتباط با سرور')
        })
    return captchaObject
})

export const postLoginData = createAsyncThunk("login/postLoginData", async(allData) => {
    const {data, userPassword, navigate, storeDispatch} = allData
    let errorMessage = '';
    await axios.post('https://demo.khedmatashayer-kj.ir/api/v1/user/login', data)
        .then((response) => {
            localStorage.setItem('userName', response.data.name)
            localStorage.setItem('userPassword', userPassword)
            localStorage.setItem('token', response.data.token)
            localStorage.setItem('userId', response.data.user_id)
        })
        .then(() => {
            navigate('home')
        })
        .catch((error) => {
            errorMessage = error.response.data.message;
            if(errorMessage === 'کد امنیتی وارد شده نادرست است!' || errorMessage === 'کد امنیتی وارد شده نامعتبر شده است .کد امنیتی جدید را وارد نمایید.' || errorMessage === 'نام کاربری یا رمز عبور اشتباه می باشد.'){
                storeDispatch(getCaptcha())
            }
        })
    return errorMessage
})

const loginSlice = createSlice({
    name: 'login',
    initialState: {
        captcha: null,
        error: ''
    },
    reducers:{},
    extraReducers(builder){
        builder
            .addCase(getCaptcha.fulfilled, (state, action) => {
                state.captcha = action.payload
            })
            .addCase(postLoginData.fulfilled, (state, action) => {
                state.error = action.payload
            })
    }
})

export const selectCaptcha = state => state.login.captcha;
export const selectLoginError = state => state.login.error;

export default loginSlice.reducer